import { fetchRequest } from "@providers/conect";

const getAllRolesApi = async () => {
  try {
    const url = `roles/all`;
    const response = await fetchRequest(url, { method: "GET" });
    return response;
  } catch (error) {
    throw error;
  }
};

const viewRolesApi = async (data) => {
  try {
    const url = `roles/view`;
    const response = await fetchRequest(url, { method: "POST", body: data });
    return response;
  } catch (error) {
    throw error;
  }
};

const createRoleApi = async (data) => {
  try {
    const url = `roles/create`;
    const response = await fetchRequest(url, { method: "POST", body: data });
    return response;
  } catch (error) {
    throw error;
  }
};

const updateRoleApi = async (id, data) => {
  try {
    const url = `roles/update/${id}`;
    const response = await fetchRequest(url, { method: "PUT", body: data });
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteRoleApi = async (id) => {
  try {
    const url = `roles/delete/${id}`;
    const response = await fetchRequest(url, { method: "DELETE" });
    return response;
  } catch (error) {
    throw error;
  }
};

export {
  getAllRolesApi,
  viewRolesApi,
  createRoleApi,
  updateRoleApi,
  deleteRoleApi
};